import { render, staticRenderFns } from "./DMARKRecordForm.vue?vue&type=template&id=efd87952&"
import script from "./DMARKRecordForm.vue?vue&type=script&lang=js&"
export * from "./DMARKRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd87952')) {
      api.createRecord('efd87952', component.options)
    } else {
      api.reload('efd87952', component.options)
    }
    module.hot.accept("./DMARKRecordForm.vue?vue&type=template&id=efd87952&", function () {
      api.rerender('efd87952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/DMARKRecordForm.vue"
export default component.exports